import { TABS_VALUES } from '@hapana/shared/web/components/shared/modal-alerts/notes-properties/modal-alerts.constants'

export const sampleModalAlertProps = {
  v1ClientId: 301244,
  profileImg: {
    url: 'https://images.unsplash.com/photo-1529665253569-6d01c0eaf7b6?auto=format&fit=crop&w=128&q=128',
  },
  name: 'Sasha Palmer',
  firstName: 'Sasha',
  failedPayments: [
    {
      id: 'failed-1',
      label: 'Unlimited Yoga',
      price: '129.00',
      currency: 'USD',
      siteName: 'Downtown Studio',
      datetime: '2024-04-12T10:00:00Z',
      v1InvoiceId: 'INV-20394',
      v1PaymentMasterId: 'PM-20394',
      v1PaymentType: 'RECURRING',
    },
    {
      id: 'failed-2',
      label: 'Pilates Foundations',
      price: '89.00',
      currency: 'USD',
      siteName: 'Midtown Studio',
      datetime: '2024-04-05T09:00:00Z',
      v1InvoiceId: 'INV-20419',
      v1PaymentMasterId: 'PM-20419',
      v1PaymentType: 'ONE_TIME',
    },
  ],
  outstandingPayments: [
    {
      id: 'outstanding-1',
      label: 'Reformer Flow',
      price: '69.00',
      currency: 'USD',
      siteName: 'Downtown Studio',
      datetime: '2024-03-28T08:00:00Z',
      v1InvoiceId: 'INV-20218',
      v1PaymentMasterId: 'PM-20218',
      v1PaymentType: 'ONE_TIME',
    },
  ],
  pendingAgreements: [
    {
      id: 'agreement-1',
      name: 'Silver membership agreement',
      date: 'Feb 1, 2021',
    },
    {
      id: 'agreement-2',
      name: 'Gold membership agreement',
      date: 'Mar 15, 2021',
    },
  ],
  formsPending: ['Liability waiver', 'Medical questionnaire'],
  homeLocations: ['Downtown Studio', 'Midtown Studio'],
  birthday: '2024-04-19T00:00:00Z',
  isFirstSession: true,
  introOffer: 'Downtown Studio',
  suspendedClient: '2023-09-21T00:00:00Z',
  clientId: undefined,
  tabDefaultValue: TABS_VALUES[0],
  hasNotesAndProperties: true,
  location: 'Downtown Studio',
  notesAndPropertiesData: {
    clientSiteNotes: [
      {
        id: 'note-1',
        text: 'Prefers slower paced classes and detailed cueing.',
        date: '2024-03-18T09:00:00Z',
      },
      {
        id: 'note-2',
        text: 'Recovering from a knee injury, avoid deep lunges.',
        date: '2024-02-06T11:20:00Z',
      },
    ],
    clientSiteAlertedProperties: [
      {
        id: 'property-1',
        title: 'Favorite Instructor',
        value: 'Jamie Reynolds',
      },
      {
        id: 'property-2',
        title: 'Class Pack Preference',
        value: 'Morning reformer, twice a week',
      },
    ],
  },
  activePackagesData: {
    clientSiteActivePackages: [
      {
        id: 'package-1',
        packageDefinition: { name: 'Unlimited Yoga', type: 'UNLIMITED' },
        creditsConsumed: 8,
        creditsTotal: 20,
        lastUsedOn: '2024-04-08T07:00:00Z',
        site: { name: 'Downtown Studio' },
        client: { v1Id: 301244 },
      },
      {
        id: 'package-2',
        packageDefinition: { name: 'Pilates Punch Card', type: 'SESSION' },
        creditsConsumed: 2,
        creditsTotal: 10,
        lastUsedOn: '2024-04-06T14:15:00Z',
        site: { name: 'Midtown Studio' },
        client: { v1Id: 301244 },
      },
    ],
  },
}

export const alertModalTabOverrides = {
  payment: TABS_VALUES[0],
  agreements: TABS_VALUES[0],
  forms: TABS_VALUES[0],
  notesProps: TABS_VALUES[1],
  location: TABS_VALUES[0],
  birthday: TABS_VALUES[0],
  packages: TABS_VALUES[0],
  firstSession: TABS_VALUES[0],
  introOffers: TABS_VALUES[0],
  suspended: TABS_VALUES[0],
  daysAbsent: TABS_VALUES[0],
} as const
